import { cn } from '@/lib/utils'
import { POTENTIAL_INFO } from '@/mocks/occurrences/catalog'
import type { Potential } from '@/types/occurrence'

const LEVELS: { value: Potential; color: string }[] = [
	{ value: 'N1', color: 'border-rose-600 bg-rose-600' },
	{ value: 'N2', color: 'border-orange-500 bg-orange-500' },
	{ value: 'N3', color: 'border-yellow-500 bg-yellow-500' },
	{ value: 'N4', color: 'border-teal-600 bg-teal-600' },
	{ value: 'N5', color: 'border-teal-500 bg-teal-500' },
]

/** Pirâmide de potencial N1–N5 como seletor (substitui a imagem estática do PowerApps). */
export const PotentialPyramid = ({
	value,
	onChange,
	disabled,
}: {
	value: Potential
	onChange: (v: Potential) => void
	disabled?: boolean
}) => (
	<div className="w-full space-y-1.5 lg:w-80">
		<p className="text-sm font-medium text-kaefer-dark-grey">Potencial</p>
		{LEVELS.map((l) => (
			<button
				type="button"
				key={l.value}
				disabled={disabled}
				onClick={() => onChange(l.value)}
				className={cn(
					'flex w-full items-center gap-2 rounded-lg border-2 p-1.5 text-left transition-all disabled:opacity-60',
					value === l.value
						? 'border-kaefer-dark-grey shadow-md'
						: 'border-transparent hover:border-kaefer-light-silver',
				)}
			>
				<span
					className={cn(
						'flex size-9 shrink-0 items-center justify-center rounded-md text-sm font-bold text-white',
						l.color,
					)}
				>
					{l.value}
				</span>
				<span className="text-[11px] leading-tight text-muted-foreground">
					{POTENTIAL_INFO[l.value]}
				</span>
			</button>
		))}
	</div>
)
